import React from "react";
import DialogBox from "../DialogBox";
import { dialogWidths } from "../DialogBox/DialogBox";
import Button from "../Button";
import Typography from "../Typography";

export type NylasDisconnectDialogProps = {
    isOpen: boolean
    onClose: () => void
    onDisconnect: () => void
    isDisconnecting?: boolean
    accountEmail?: string | null
};

const NylasDisconnectDialog: React.FC<NylasDisconnectDialogProps> = ({
    isOpen,
    onClose,
    onDisconnect,
    isDisconnecting,
    accountEmail,
}) => {
    return (
        <DialogBox
            isOpen={isOpen}
            onClose={onClose}
            title="Disconnect calendar?"
            maxWidth={dialogWidths.medium}
        >
            <Typography variant="body" component="p">
                {accountEmail
                    ? `Your calendar (${accountEmail}) will stop syncing and events will no longer appear on the platform.`
                    : "Your calendar will stop syncing and events will no longer appear on the platform."}
            </Typography>
            <Typography variant="body" component="p">
                You can reconnect this or a different calendar at any time.
            </Typography>
            <div className="flex flex-col-reverse md:flex-row gap-4">
                <Button
                    className="mx-auto w-full"
                    type="button"
                    variant="secondary"
                    onClick={onClose}
                    disabled={isDisconnecting}
                >
                    Cancel
                </Button>
                <Button
                    className="mx-auto w-full"
                    type="button"
                    variant="primary"
                    onClick={onDisconnect}
                    loading={isDisconnecting}
                    disabled={isDisconnecting}
                >
                    Disconnect calendar
                </Button>
            </div>
        </DialogBox>
    );
};

export default NylasDisconnectDialog;
